import axios from 'axios';
import { getGuestSessionId } from '../utils/session';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    // If no token (guest user), add session ID header
    const sessionId = getGuestSessionId();
    config.headers['X-Session-ID'] = sessionId;
  }

  // For FormData requests, remove the default Content-Type header
  // to let axios set it automatically with the boundary
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type'];
  }

  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Only redirect to login if we're not already on the login or register page
      const currentPath = window.location.pathname;
      if (currentPath !== '/' && currentPath !== '/register') {
        localStorage.removeItem('access_token');
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;